<div [ngClass]="'cc-table-form-field'">
  <span class="sub-form-container">
    <p-table [value]="formRecords" editMode="row" responsiveLayout="scroll">
        <ng-template pTemplate="header">
          <tr>
            <ng-template ngFor let-fieldGroup [ngForOf]="formRichFieldConfig.fields" let-groupIndex="index">
              <ng-template ngFor let-fieldConfig [ngForOf]="fieldGroup.fields" let-fieldIndex="index"
                           *ngIf="!fieldValueMap['hiddenGroup-' + groupIndex + '_' + 0]">
                <th *ngIf="fieldConfig.field && fieldConfig.type!=FieldTypes.CHECKBOX" [for]="fieldConfig.field"
                    [className]="fieldConfig.required===true?'field-required':''"
                    [innerHTML]="fieldConfig.label ? fieldConfig.label : 'page.' + this.transPartKey + '.form.' + fieldConfig.field | translate">
                </th>
              </ng-template>
            </ng-template>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-formRecord let-editing="true" let-recordIndex="rowIndex">
            <tr [pEditableRow]="formRecord">
                <ng-template ngFor let-fieldGroup [ngForOf]="formRichFieldConfig.fields"
                             let-groupIndex="index">
                  <ng-template ngFor let-fieldConfig [ngForOf]="fieldGroup.fields" let-fieldIndex="index"
                               *ngIf="!fieldValueMap['hiddenGroup-' + groupIndex + '_' + recordIndex]">
                    <td [class]="fieldConfig.class">
                      <p-cellEditor>
                        <ng-template pTemplate="output">
                          <app-cc-field-dispatcher #ccSubForm
                            *ngIf="formRecord&&!fieldValueMap['hiddenField-' + groupIndex + '_' + fieldIndex + '_' + recordIndex]"
                            [loading]="disabled" [transPartKey]="transPartKey"
                            [(formRecord)]="formRecords[recordIndex]"
                            [fieldConfig]="fieldConfig"
                            (formRecordChange)="reloadFieldValueMap();this.formRecordsChange.emit(this.formRecords);">
                          </app-cc-field-dispatcher>
                        </ng-template>
                      </p-cellEditor>
                    </td>
                  </ng-template>
                </ng-template>
            </tr>
        </ng-template>
    </p-table>
  </span>
</div>
